import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "CategoryFilterBar"
}
const _hoisted_2 = { class: "CategoryFilterBarItem-value" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512",
  width: "10",
  height: "10"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "CategoryFilterBarItem-value" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512",
  width: "10",
  height: "10"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"
  })
], -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.changedSlides || _ctx.selectedChecks)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.changedSlides, (slide) => {
          return (_openBlock(), _createElementBlock("div", {
            key: slide.nameMin + '|' +  slide.nameMax,
            class: "CategoryFilterBarItem"
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(slide.minValue.toLocaleString() + " - " + slide.maxValue.toLocaleString() + " " + slide.unit), 1),
            _createElementVNode("button", {
              class: "CategoryFilterBarItem-remove",
              onClick: ($event: any) => (_ctx.clearSelected({ type: slide.nameMin }))
            }, _hoisted_5, 8, _hoisted_3)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedChecks, (check) => {
          return (_openBlock(), _createElementBlock("div", {
            key: check.name + '=' +  check.value,
            class: "CategoryFilterBarItem"
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(check.label), 1),
            _createElementVNode("button", {
              class: "CategoryFilterBarItem-remove",
              onClick: ($event: any) => (_ctx.clearSelected({ name: check.name, value: check.value }))
            }, _hoisted_9, 8, _hoisted_7)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}